import { effect } from '../signals.js';
import {
  searchTerm,
  loading,
  updateSearch,
  clearSearch
} from '../cocktail-state.js';
import { Log } from '../logger.js';

const _log = Log('cocktail-header.js');

class CocktailHeader extends HTMLElement {
  constructor() {
    super();
    this.collapseContent = false;
  }

  connectedCallback() {
    _log.green('Header component connected');
    this.renderStructure();
    this.setupSearch();
    this.setupToggle();
    this.setupReactiveEffects();
  }

  renderStructure() {
    this.innerHTML = `
      <div class="header">
        <div class="header-content">
          <h1 class="header-title">Cocktail Diary</h1>
          <div class="header-controls">
            <div class="search-container">
              <input 
                type="search" 
                class="search-input"
                placeholder="Search cocktails..." 
                autocomplete="off"
              >
              <button class="clear-search" hidden>✕</button>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" class="collapse-toggle">
              <span class="toggle-slider"></span>
              <span class="toggle-label">Collapse Recipes</span>
            </label>
          </div>
        </div>
      </div>
    `;
  }

  setupSearch() {
    const searchInput = this.querySelector('.search-input');
    const clearButton = this.querySelector('.clear-search');

    searchInput?.addEventListener('input', (e) => {
      const value = e.target.value.trim();
      updateSearch(value);

      // Show/hide clear button
      if (clearButton) {
        clearButton.hidden = !value;
      }
    });

    clearButton?.addEventListener('click', () => {
      if (searchInput) {
        searchInput.value = '';
      }
      clearSearch();
      clearButton.hidden = true;
    });
  }

  setupToggle() {
    const toggle = this.querySelector('.collapse-toggle');

    // Load saved preference
    const saved = localStorage.getItem('collapseContent') === 'true';
    this.collapseContent = saved;
    if (toggle) toggle.checked = saved;
    this.updateCollapseState();

    toggle?.addEventListener('change', (e) => {
      this.collapseContent = e.target.checked;
      localStorage.setItem('collapseContent', String(this.collapseContent));
      this.updateCollapseState();
    });
  }

  setupReactiveEffects() {
    // React to loading state
    effect(() => {
      const isLoading = loading.value;
      const searchInput = this.querySelector('.search-input');
      if (searchInput) {
        searchInput.disabled = isLoading;
      }
    });

    // React to search term changes (for programmatic updates)
    effect(() => {
      const term = searchTerm.value;
      const searchInput = this.querySelector('.search-input');
      const clearButton = this.querySelector('.clear-search');

      if (searchInput && searchInput.value !== term) {
        searchInput.value = term;
      }

      if (clearButton) {
        clearButton.hidden = !term;
      }
    });
  }

  updateCollapseState() {
    // Dispatch custom event for other components to listen to
    this.dispatchEvent(new CustomEvent('collapse-changed', {
      detail: { collapsed: this.collapseContent },
      bubbles: true
    }));
  }
}

customElements.define('cocktail-header', CocktailHeader);
